import type { NextPage } from 'next'
import Head from 'next/head'

import { RefundPolicySlice } from '@/slices/Help'
import { Layout } from '@/slices/Layout'
import { getLayoutProps } from '@/slices/Layout/global/layout'

const RefundPolicyPage: NextPage = () => {
  const layoutProps = getLayoutProps()

  return (
    <>
      <Head>
        <title>Refund Policy | Pixie World</title>
        <meta
          name="description"
          content="Learn about PixieWorld's refund policy: 30-day money-back guarantee on digital products and 7-day damage guarantee on physical books."
        />
      </Head>

      <Layout {...layoutProps}>
        <RefundPolicySlice />
      </Layout>
    </>
  )
}

export default RefundPolicyPage
